<template>
  <div>
    <column-node v-if="!!content" :content="content" v-on="$listeners" />
    <slot v-else />

    <v-text-field :value="parameterAnswered" disabled :rules="[$validation.required()]" class="d-none" />
  </div>
</template>

<script>
import { Method } from '@/_typedefs'
import ColumnNode from '../Column/ColumnNode.vue'

/** @typedef {Record<string, {score: number?, label: string, hidden: boolean?}>} Parameters */

export default {
  components: { ColumnNode },
  name: 'ParametersWrapperNode',
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /** @type {string?} */
      parameterAnswered: null,
      /** @type {Function?} */
      unwatch: null,
    }
  },
  methods: {
    /** @type {Method<[parameters: Parameters], boolean>} */
    calculateParameterAnswered(parameters) {
      return Object.entries(parameters)
        .filter(([_name, value]) => !value.hidden)
        .some(([_name, value]) => !!value.score)
        ? 'yes'
        : null
    },
  },
  created() {
    const parameters = this.$store.getters['newAttendanceForm/parameters']
    this.parameterAnswered = this.calculateParameterAnswered(parameters)
    this.unwatch = this.$store.subscribe((mutation, state) => {
      if (mutation.type !== 'newAttendanceForm/updateParameter') {
        return
      }

      this.parameterAnswered = this.calculateParameterAnswered(state.newAttendanceForm.parameters)
    })
  },
  beforeDestroy() {
    this.unwatch?.()
  },
}
</script>

<style></style>
